"use client";

import { useSession } from "@/lib/auth-client";

/**
 * Hook for displaying admin UI elements (navbar button, etc.)
 *
 * SECURITY NOTE: This hook ONLY controls UI visibility, NOT access control.
 * Actual admin access is secured by:
 * - middleware.ts: Protects /admin-* and /api/admin/* routes
 * - Server-side session validation on all admin APIs
 * - Google SSO with @crowdsec.net domain restriction
 *
 * This hook is safe for client-side use and cannot bypass server-side security.
 */
export function useAdminAccess() {
  const { data: session, isPending } = useSession();

  // Only show admin UI elements if user is actually authenticated with valid domain
  const hasAdminAccess =
    !isPending && !!session?.user?.email?.endsWith("@crowdsec.net");

  return {
    hasAdminAccess,
    isAuthenticated: !!session?.user,
    isLoading: isPending,
  };
}
